module.exports = __webpack_public_path__ + "img/station_04.ad3fbd52.jpg";